<div #navmenu fxLayout="column" fxLayoutAlign="start stretch">
    <ng-container *ngFor="let item of FilteredItems">
        <ng-container *ngIf="item.DisplayAsMenu && item.Enabled">
            <button
                type="button"
                mat-raised-button
                disableRipple
                [attr.id]="'NavBtn_' + item.ButtonIndex"
                [color]="item.Active ? 'primary' : null"
                (click)="HandleItemClick(item)"
            >
                <div fxLayout="row" fxLayoutAlign="space-between center">
                    <div fxLayout="row" fxLayoutAlign="start center">
                        <ng-container *ngIf="item.MenuIcon">
                            <mat-icon
                                *ngIf="item.SVGIcon; else regular_icon"
                                [ngClass]="item.IconClasses || []"
                                [svgIcon]="item.MenuIcon"
                            ></mat-icon>
                            <ng-template #regular_icon>
                                <mat-icon [ngClass]="item.IconClasses || []">{{ item.MenuIcon }}</mat-icon>
                            </ng-template>
                        </ng-container>
                        <span>{{ item.MenuText }}</span>
                    </div>
                    <mat-icon *ngIf="item.Submenus && !!item.Submenus.length && !HideChevrons" [@iconspinner]="item.IsExpanded"
                        >chevron_right</mat-icon
                    >
                </div>
            </button>
            <div
                [@submenuexpand]="item.IsExpanded ? 'expanded' : 'collapsed'"
                class="submenu"
                fxLayout="column"
                fxLayoutAlign="start stretch"
            >
                <ng-container *ngFor="let subitem of item.Submenus">
                    <ng-container *ngIf="subitem.DisplayAsMenu && subitem.Enabled && item.IsExpanded">
                        <button
                            type="button"
                            mat-raised-button
                            disableRipple
                            [attr.id]="'NavBtn_' + subitem.ButtonIndex"
                            [color]="subitem.Active ? 'primary' : null"
                            (click)="HandleItemClick(subitem)"
                            [class.warnbackground100]="!subitem.Active && subitem.Completed === NavMenuItemStatus.Incomplete"
                            [class.warnbackground100contrast]="!subitem.Active && subitem.Completed === NavMenuItemStatus.Incomplete"
                            [class.accentbackground100]="!subitem.Active && subitem.Completed === NavMenuItemStatus.Completed"
                            [class.accentbackground100contrast]="!subitem.Active && subitem.Completed === NavMenuItemStatus.Completed"
                            [class.amberbackground50]="!subitem.Active && subitem.Completed === NavMenuItemStatus.Optional"
                            [class.amberbackground50contrast]="!subitem.Active && subitem.Completed === NavMenuItemStatus.Optional"
                            [class.lightbluebackground50]="!subitem.Active && subitem.Completed === NavMenuItemStatus.Info"
                            [class.lightbluebackground50contrast]="!subitem.Active && subitem.Completed === NavMenuItemStatus.Info"
                        >
                            <div fxLayout="row" fxLayoutAlign="space-between center">
                                <div fxLayout="row" fxLayoutAlign="start center">
                                    <ng-container *ngIf="subitem.MenuIcon && subitem.DisplayAsMenu">
                                        <mat-icon
                                            *ngIf="subitem.SVGIcon; else regular_icon"
                                            [ngClass]="item.IconClasses || []"
                                            [svgIcon]="subitem.MenuIcon"
                                        ></mat-icon>
                                        <ng-template #regular_icon>
                                            <mat-icon [ngClass]="item.IconClasses || []">{{ subitem.MenuIcon }}</mat-icon>
                                        </ng-template>
                                    </ng-container>
                                    <span>{{ subitem.MenuText }}</span>
                                </div>
                                <mat-icon
                                    *ngIf="subitem.Completed != null"
                                    [class.accentforeground500]="subitem.Completed === NavMenuItemStatus.Completed"
                                    [class.warnforeground500]="subitem.Completed === NavMenuItemStatus.Incomplete"
                                    [class.amberforeground800]="
                                        subitem.Completed === NavMenuItemStatus.Optional ||
                                        (subitem.Completed === NavMenuItemStatus.Info && subitem.Active)
                                    "
                                    [class.lightblueforeground500]="subitem.Completed === NavMenuItemStatus.Info && !subitem.Active"
                                    matTooltip="This item is optional."
                                    [matTooltipDisabled]="subitem.Completed !== NavMenuItemStatus.Info"
                                >
                                    {{
                                        subitem.Completed === NavMenuItemStatus.Completed
                                            ? 'done'
                                            : subitem.Completed === NavMenuItemStatus.Optional
                                            ? 'warning'
                                            : subitem.Completed === NavMenuItemStatus.Info
                                            ? 'lightbulb'
                                            : 'close'
                                    }}
                                </mat-icon>
                            </div>
                        </button>
                    </ng-container>
                </ng-container>
            </div>
        </ng-container>
    </ng-container>
</div>
